import { forwardRef } from 'react'
import { cn } from '../utils/cn.ts'

export interface ExpressPayButtonProps {
  type: 'apple-pay' | 'google-pay'
  disabled?: boolean
  onClick?: () => void
  className?: string
}

const brandLabels: Record<ExpressPayButtonProps['type'], string> = {
  'apple-pay': 'Apple Pay',
  'google-pay': 'Google Pay',
}

export const ExpressPayButton = forwardRef<HTMLDivElement, ExpressPayButtonProps>(
  function ExpressPayButton({ type, disabled = false, onClick, className }, ref) {
    const label = brandLabels[type]

    function handleClick() {
      if (!disabled && onClick) {
        onClick()
      }
    }

    return (
      <div
        ref={ref}
        role="button"
        aria-label={label}
        aria-disabled={disabled || undefined}
        tabIndex={disabled ? -1 : 0}
        className={cn(
          'express-pay-btn',
          type === 'apple-pay' && 'express-pay-apple',
          type === 'google-pay' && 'express-pay-google',
          disabled && 'express-pay-btn-disabled',
          className,
        )}
        onClick={handleClick}
      >
        {label}
      </div>
    )
  },
)
